module.exports = __webpack_public_path__ + "static/media/material_bg.abe4a318.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/material_bg.png
// module id = 774
// module chunks = 0